module.exports = __webpack_public_path__ + "static/media/newFlyers1.93c27f53.jpeg";